import '@visactor/vrender-core';
import {
  container,
  isBrowserEnv,
  isNodeEnv,
  preLoadAllModule,
  registerFlexLayoutPlugin,
  registerViewTransform3dPlugin,
  registerHtmlAttributePlugin,
  registerReactAttributePlugin,
  registerDirectionalLight,
  registerOrthoCamera
} from '@visactor/vrender-core';
import { loadBrowserEnv, loadNodeEnv, registerStar } from '@visactor/vrender-kits';
import {
  registerArc,
  registerArc3d,
  registerArea,
  registerCircle,
  registerGlyph,
  registerGroup,
  registerImage,
  registerLine,
  registerPath,
  registerPolygon,
  registerPyramid3d,
  registerRect,
  registerRect3d,
  registerRichtext,
  registerShadowRoot,
  registerSymbol,
  registerText,
  registerWrapText
} from '@visactor/vrender-kits';
import { registerCustomAnimate, registerAnimate } from '@visactor/vrender-animate';
// 导出版本号
export const version = "1.0.46";

preLoadAllModule();

if (isBrowserEnv()) {
  loadBrowserEnv(container);
} else if (isNodeEnv()) {
  loadNodeEnv(container);
}
registerArc();
registerArc3d();
registerArea();
registerCircle();
registerGlyph();
registerGroup();
registerImage();
registerLine();
registerPath();
registerPolygon();
registerPyramid3d();
registerRect();
registerRect3d();
registerRichtext();
registerShadowRoot();
registerSymbol();
registerText();
registerWrapText();
registerStar();

registerFlexLayoutPlugin();
registerViewTransform3dPlugin();
registerHtmlAttributePlugin();
registerReactAttributePlugin();
registerDirectionalLight();
registerOrthoCamera();

registerCustomAnimate();
registerAnimate();

export * from '@visactor/vrender-core';
export * from '@visactor/vrender-kits';
export * from '@visactor/vrender-animate';
export * from '@visactor/vrender-components';

// avoid naming conflicts with 'State' & 'Direction' in '@visactor/vrender-components'
export { State } from '@visactor/vrender-animate';
export { Direction } from '@visactor/vrender-core';
